// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialDrawer from "@material-ui/core/Drawer";
import { excludeKeys } from "./../utils";
const useStylesForSidewaysMegamenuDrawer = makeThemedStyles(
  "SidewaysMegamenuDrawer",
  (theme) => ({
    SidewaysMegamenuDrawer: {},
  })
);
type PropType = React.ComponentProps<typeof MaterialDrawer>;
const SidewaysMegamenuDrawer: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForSidewaysMegamenuDrawer();
  const enabledClasses = excludeKeys(styles, [
    "SidewaysMegamenuDrawer",
    "SidewaysMegamenuToolbar",
  ]);
  /* eslint-disable */
  return (
    <MaterialDrawer
      {...props}
      classes={{
        root: styles.SidewaysMegamenuDrawer,
        ...enabledClasses,
      }}
      className={clsx(styles.SidewaysMegamenuDrawer)}
    >
      {props?.children}
    </MaterialDrawer>
  );
};
export default SidewaysMegamenuDrawer;
